import React, { useState } from 'react';
import { Layout, Tabs } from 'antd';
import {
    DollarCircleOutlined,
    BarChartOutlined,
    ShopOutlined,
} from '@ant-design/icons';
import HeaderTop from '../../../components/General/HeaderTop';
import SellTable from '../../../components/Admin/SellTable';
import TopSelling from '../../../components/Admin/TopSelling';
import AuthForm from '../../../components/Admin/AuthForm/AuthForm';
import ListRestaurants from '../../../components/Admin/Restaurants/ListRestaurants';

import './AllRestReport.scss';

const AllRestReport = () => {
    const { Content } = Layout;
    const { TabPane } = Tabs;
    const [isAuth, setIsAuth] = useState(false);

    return (
        <Layout className="all-report">
            <Content>
                <HeaderTop
                    title={'Reportes Generales'}
                    backIcon={true}
                    backUrl="/admin"
                />
                {isAuth && (
                    <Tabs defaultActiveKey="3" centered className="report-tabs">
                        <TabPane
                            tab={
                                <span className="report-tabs__title">
                                    <ShopOutlined />
                                    Restaurantes
                                </span>
                            }
                            key="3"
                        >
                            <ListRestaurants />
                        </TabPane>
                        <TabPane
                            tab={
                                <span className="report-tabs__title">
                                    <DollarCircleOutlined />
                                    Control de Ventas
                                </span>
                            }
                            key="1"
                        >
                            <SellTable allRest />
                        </TabPane>
                        <TabPane
                            tab={
                                <span className="report-tabs__title">
                                    <BarChartOutlined />
                                    Ranking
                                </span>
                            }
                            key="2"
                        >
                            <TopSelling allRest />
                        </TabPane>
                    </Tabs>
                )}
                {!isAuth && (
                    <div className="all-report__container">
                        <AuthForm setIsAuth={setIsAuth} />
                    </div>
                )}
            </Content>
        </Layout>
    );
};

export default AllRestReport;
